import styled, { css } from 'styled-components';
import Button from '@carvana/forms/Button';
import { ArrowForward } from '@carvana/icons';
import { cvBreakpoint768 } from '@carvana/theme';
import { DocWizardSection } from '../../document-wizard.styles';

const commonStyles = {
  docImgMaxWd: 'max-width: 462px;'
};

export const DocumentPreviewWrapper = styled(DocWizardSection)`
  align-items: center;
  background-color: ${props => props.theme.carvana.gray.background};
  flex-direction: column;
  padding: 40px 24px 56px;
  position: relative;
`;

export const Carousel = styled.div`
  ${commonStyles.docImgMaxWd}
  overflow: hidden;
`;

export const CarouselTrack = styled.div`
  display: flex;

  & > .document-image {
    ${commonStyles.docImgMaxWd}
  }

  ${props => {
    let slideClasses = '';

    for(let i = 0; i < props.slideCount; i++) {
      slideClasses += `
        &.slide-${i}-active {
          transform: translateX(-${i}00%);
          transition: transform .75s cubic-bezier(0.68, -0.2, 0.32, 1.2);
        }      
      `;
    }

    return slideClasses;
  }}
`;

export const ArrowButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const NextImgButton = styled(ArrowForward)`
  ${props => !props.disabled && 'cursor: pointer'};

  & > svg {
    height: 35;
  }

  & > svg > g {
    fill: ${props => props.disabled
      ? props.theme.carvana.gray.light
      : props.theme.carvana.blue.primary};
  }
`;

export const PrevImgButton = styled(NextImgButton)`
  margin-right: 20px;
  transform: scaleX(-1);
`;

export const DocumentPreviewFooter = styled.footer`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 0 16px 16px;
  position: absolute;
  right: 0;

  @media (min-width: ${cvBreakpoint768}px) {
    justify-content: flex-start;
  }
`;

export const FooterButton = styled(Button).attrs({
  ghost: true
})`
  border-color: transparent;
  font-size: 14px;
  height: 32px;
  min-height: auto;
  padding: 0;
  text-transform: none;
  width: 70px;
`;

export const FullViewButton = styled(FooterButton)`
  &:hover {
    background-color: inherit;
    color: ${props => props.theme.carvana.blue.primary};;
  }
`;

export const footerTextDividerStyles = css`
  color: ${props => props.theme.carvana.gray.medium};
  display: none;
  font-size: 14px;
  margin: 0 8px;

  @media (min-width: ${cvBreakpoint768}px) {
    display: block;
  }
`;

export const FileName = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: bold;

  @media (min-width: ${cvBreakpoint768}px) {
    font-size: 14px;
  }
`;

export const ReuploadButton = styled(FooterButton)`
  @media (min-width: ${cvBreakpoint768}px) {
    border-color: inherit;
    margin-left: auto;
    width: 120px;
  }
`;
